import { render, staticRenderFns } from "./package-track-details.vue?vue&type=template&id=f957d56c&scoped=true"
import script from "./package-track-details.vue?vue&type=script&setup=true&lang=js"
export * from "./package-track-details.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f957d56c",
  null
  
)

export default component.exports